import { useRef } from "react";
import { useTranslation } from "react-i18next";
import Summary from "../components/Home/Summary";
import MetaTags from "../components/common/MetaTags";

const Newmove = () => {
  const { t } = useTranslation("", { keyPrefix: "Newmove" });
  const summaryRef = useRef<HTMLDivElement | null>(null);

  return (
    <>
      <MetaTags t={t} />
      <Summary refProp={summaryRef} />
    
    </>
  );
};

export default Newmove;
